import React, { Component } from 'react'
import './GalleryPageVideoCards.css';
import {Videos_main,YoutubCards} from "../../data"
import ReactPlayer from "react-player"


export default class GalleryPageCards extends Component {
    render() {
        return (
            <>
            <div className="gpcv-row"> 
                {
                YoutubCards.map(item =>(
                    <div className={`gpcv-column ${item.className}`}>
                        <ReactPlayer
                            url={item.videourl}
                            width='100%'
                            height='100%'
                            playIcon={<img src={Videos_main.Play} alt="Video-card" className="play-icon-class"/>}
                            // light={youtubeThumbnailProps.youtubeThumbnail}
                            light={true}
                            controls={true}
                            playing
                        />
                        <div className="gpcv-text-group">
                            <div className="gpcv-header">
                                {item.text129}
                            </div>
                            <div className="gpcv-para">
                                {item.address}
                            </div>
                        </div>
                    </div>
                ))
                }
                
            </div>
        </>
        )
    }
}








